module.exports = __webpack_public_path__ + "img/tps-logo.e0a9cbc6.png";